/**
 * @param {String} [text]
 * @param {Number} [length]
 * @param {String} [clamp]
 *
 * @return {String}
 */
export default function truncate(text = "", length = 30, clamp = "...") {
  return text.length > length
    ? text
      .slice(0, length - clamp.length)
      .split(" ")
      .slice(0, -1)
      .join(" ") + clamp
    : text;
}
